import { PageHeader } from '@/components/ui/PageHeader';
import { StatusCheck } from '@/features/status';

export function StatusPage() {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <PageHeader
        title="System Status"
        description="Live health status for the management API, database, and workflow services."
      />
      <StatusCheck />
    </div>
  );
}
